// src/pages/SubscriptionSuccess.js
import { useLocation, Link } from 'react-router-dom';

function SubscriptionSuccess() {
  const { state } = useLocation();
  const subscription = state?.subscription || {};

  return (
    <div style={{
      minHeight: '80vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '40px 20px',
    }}>
      <div style={{ width: '100%', maxWidth: 480, textAlign: 'center' }}>

        {/* Success mark */}
        <div style={{
          width: 72,
          height: 72,
          background: 'var(--primary-dim)',
          border: '2px solid var(--primary-color)',
          borderRadius: '50%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          margin: '0 auto 24px',
          fontSize: 28,
        }}>✓</div>

        <h1 style={{
          fontSize: 32,
          fontWeight: 800,
          letterSpacing: '-0.03em',
          color: 'var(--text-primary)',
          marginBottom: 12,
        }}>
          Velkommen til Faircast
        </h1>
        <p style={{ fontSize: 17, color: 'var(--text-secondary)', lineHeight: 1.6, marginBottom: 32 }}>
          Dit abonnement er aktivt. 80% af dine 30 kr går direkte til de podcasts du lytter til.
        </p>

        {/* Subscription details */}
        <div style={{
          background: 'var(--bg-card)',
          border: '1px solid var(--border-color)',
          borderRadius: 16,
          padding: '20px 24px',
          marginBottom: 32,
          textAlign: 'left',
        }}>
          <div style={{ fontSize: 11, fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.08em', color: 'var(--text-mute)', marginBottom: 16 }}>
            Abonnementsdetaljer
          </div>
          {[
            { label: 'Plan', value: subscription.planId === 'monthly' ? 'Månedlig' : subscription.planId ? 'Årlig' : 'Månedlig — 30 kr/md.' },
            { label: 'Status', value: 'Aktiv', highlight: true },
            { label: 'Næste betaling', value: subscription.currentPeriodEnd
                ? new Date(subscription.currentPeriodEnd).toLocaleDateString('da-DK')
                : 'Om 30 dage' },
          ].map(row => (
            <div key={row.label} style={{
              display: 'flex',
              justifyContent: 'space-between',
              padding: '8px 0',
              fontSize: 14,
              borderBottom: '1px solid var(--border-color)',
            }}>
              <span style={{ color: 'var(--text-secondary)' }}>{row.label}</span>
              <span style={{
                fontWeight: 700,
                color: row.highlight ? 'var(--primary-color)' : 'var(--text-primary)',
              }}>{row.value}</span>
            </div>
          ))}
        </div>

        {/* Next steps */}
        <div style={{
          background: 'var(--bg-card)',
          border: '1px solid var(--border-color)',
          borderRadius: 16,
          padding: '20px 24px',
          marginBottom: 32,
          textAlign: 'left',
        }}>
          <div style={{ fontSize: 11, fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.08em', color: 'var(--text-mute)', marginBottom: 16 }}>
            Hvad sker der nu?
          </div>
          {[
            { icon: '📱', text: 'Download Faircast-appen og log ind med din nye konto.' },
            { icon: '🎧', text: 'Find de podcasts du elsker og begynd at lytte.' },
            { icon: '📊', text: 'Se præcis hvad dine penge gør under "Du lytter til".' },
          ].map(item => (
            <div key={item.icon} style={{ display: 'flex', gap: 12, padding: '8px 0', fontSize: 14, color: 'var(--text-secondary)' }}>
              <span style={{ flexShrink: 0 }}>{item.icon}</span>
              <span style={{ lineHeight: 1.5 }}>{item.text}</span>
            </div>
          ))}
        </div>

        <div style={{ display: 'flex', gap: 12, justifyContent: 'center', flexWrap: 'wrap' }}>
          <Link to="/" className="fc-cta-primary">Gå til forsiden</Link>
          <Link to="/subscription/manage" className="fc-cta-ghost">Administrer abonnement</Link>
        </div>
      </div>
    </div>
  );
}

export default SubscriptionSuccess;
